import PROD_CONFIG from './config.prod';
import DEV_CONFIG from './config.dev';

export const CONFIG =
  process.env.NODE_ENV === 'production' ? PROD_CONFIG : DEV_CONFIG;
